export default "__VITE_ASSET__DUOloJDf__"